export enum BuildObject {
  BUILD = 'build',
}

export enum BuildAction {
  CREATED = 'created',
}

export type BuildOutcome = 'success' | 'failed'

type BuildCreatedProperties = {
  outcome: BuildOutcome
}

export type BuildCreatedEvent = { object: BuildObject.BUILD; action: BuildAction.CREATED }

export type BuildAnalyticsObject = { event: BuildCreatedEvent; properties: BuildCreatedProperties }
